import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist/lib'
import localForage from 'localforage'
import persistCheckVersionTransform from 'persist-check-version-transform'
import immutableTransform from './redux-persist-transform-immutable'
import sessionStorage from 'redux-persist/lib/storage/session'
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1'

import p from '../pass'
import q from '../pass2'
import r from '../pass3'

// config
import { config } from '../Config/ConfigLoader'

// types
import type { ProductState } from '../Core/Redux/Types/ProductStateType'
import type { QuoteState } from '../Core/Redux/Types/QuoteStateType'
import type { OfferStateType } from '../Core/Redux/Types/OfferStateType'
import type { FilterStateType } from '../Core/Redux/Types/FilterStateType'

const storage = config.getConfig('isBackOffice') ? sessionStorage : localForage

const persistWhitelist = ['navigation', 'offer', 'quote', 'general', 'product', 'filter', 'discounts', 'linkBuilder']
const reduxStore = {
  general: {
    redux: require('../Core/Redux/GeneralRedux'),
    blacklist: ['allErrors', 'errors', 'fetching', 'redirectUrl'],
    version: 2,
  },
  navigation: {
    redux: require('../Core/Redux/NavigationRedux'),
    blacklist: ['isMobile', 'nextPage', 'webType'],
    version: 5,
  },
  userData: {
    redux: require('../Core/Redux/UserDataRedux'),
    blacklist: ['restoredLink'],
    encrypt: true,
    version: 4
  },
  quote: {
    redux: require('../Core/Redux/QuoteRedux'),
    blacklist: ['activeSorts', 'toUnsubscribe', 'stompConnected', 'sendToEmailQuotes', 'timeAsyncRequest'],
    version: 4,
  },
  offer: {
    redux: require('../Core/Redux/OfferRedux'),
    version: 4,
    blacklist: ['termsAgree'],
    encrypt: true,
  },
  product: {
    redux: require('../Core/Redux/ProductRedux'),
    whitelist: ['productName'],
    version: 2,
  },
  validation: { redux: require('../Core/Redux/ValidationRedux') },
  debug: { redux: require('../Core/Redux/DebugRedux') },
  inputHelps: { redux: require('../Core/Redux/InputHelpsRedux') },
  filter: {
    redux: require('../Core/Redux/FilterRedux'),
    whitelist: ['enabledCalculators'],
    version: 1,
  },
  settings: { redux: require('../Core/Redux/SettingsRedux') },
  discounts: {
    redux: require('../Core/Redux/DiscountsRedux'),
    version: 5,
  },
  linkBuilder: {
    redux: require('../Core/Redux/LinkBuilderRedux'),
    version: 1,
    blacklist: ['productLinkData', 'data', 'link', 'previousLinkRequest', 'actualLinkRequest' ],
    whiteList: ['requestLinkId'],
  },
  gtm: { redux: require('../Core/Redux/GTMRedux') },
}

const g = p + q + r
const persistConfig = {
  key: 'suri',
  storage: storage,
  transforms: [immutableTransform(), persistCheckVersionTransform(reduxStore, ['userData'], g)],
  whitelist: ['userData'],
  stateReconciler: autoMergeLevel1,
}
let subProductNameElement = false
if (typeof document !== 'undefined') {
  subProductNameElement = document.getElementById('subProductName')
}
let subProductName = 'default'
if (subProductNameElement) {
  if (config.getConfig('subProductNames').includes(subProductNameElement.value)) {
    subProductName = subProductNameElement.value
  }
  subProductNameElement.value = subProductName
}
const persistConfig2 = {
  key: `${config.getConfig('productName')}-${subProductName}`,
  storage: storage,
  transforms: [immutableTransform(), persistCheckVersionTransform(reduxStore, persistWhitelist, g)],
  whitelist: persistWhitelist,
}

export type GlobalState = {
  product: ProductState,
  quote: QuoteState,
  offer: OfferStateType,
  filter: FilterStateType,
}

export const getProductState = (oldState, cl) => {
  const newState = {
    userData: oldState['userData'],
    ...oldState['appData'],
  }
  return cl(newState)
}

export const makeRootReducer = () => {
  return persistReducer(persistConfig,
    combineReducers({
      userData: reduxStore.userData.redux.reducer,
      appData: persistReducer(persistConfig2,
        combineReducers({
          product: reduxStore.product.redux.reducer,
          general: reduxStore.general.redux.reducer,
          navigation: reduxStore.navigation.redux.reducer,
          validation: reduxStore.validation.redux.reducer,
          quote: reduxStore.quote.redux.reducer,
          offer: reduxStore.offer.redux.reducer,
          debug: reduxStore.debug.redux.reducer,
          inputHelps: reduxStore.inputHelps.redux.reducer,
          filter: reduxStore.filter.redux.reducer,
          settings: reduxStore.settings.redux.reducer,
          discounts: reduxStore.discounts.redux.reducer,
          linkBuilder: reduxStore.linkBuilder.redux.reducer,
          gtm: reduxStore.gtm.redux.reducer,
        }))
    })
  )
}

export default makeRootReducer
